import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { CartProvider } from './context/CartContext';
import { clearBrowserCachesAfterInactivity } from './utils/browserCache';

const renderApp = async () => {
  try {
    await clearBrowserCachesAfterInactivity();
  } catch (error) {
    console.warn('No se pudo actualizar el cache antes de iniciar.', error);
  }

  // Keep static HTML visible until the initial route chunk is ready. This is
  // client mounting, not hydration: the SSG template is intentionally different.
  const path = window.location.pathname;
  if (path === '/') await import('./pages/HomePage');
  else if (path === '/productos' || path === '/promociones' || /^\/(subcategorias|categorias)\//.test(path)) await import('./pages/ProductsPage');
  else if (path.startsWith('/producto/')) await import('./pages/ProductDetailPage');
  else if (path === '/locales' || path === '/sucursales') await import('./pages/LocalesPage');
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <CartProvider>
      <App />
    </CartProvider>
  );
};

void renderApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
